import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "65",
  height: "64",
  fill: "none",
  viewBox: "0 0 65 64"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<rect width=\"38\" height=\"38\" x=\"13.666\" y=\"13\" fill=\"#183E44\" rx=\"6\"></rect><path fill=\"#45909C\" d=\"M26.667 13h15v14.267a1 1 0 0 1-1.5.866l-4-2.31a4 4 0 0 0-4.002 0l-3.998 2.31a1 1 0 0 1-1.5-.866z\"></path><circle cx=\"32.666\" cy=\"32\" r=\"25\" stroke=\"#FF944C\" stroke-width=\"6\"></circle><circle cx=\"32.666\" cy=\"32\" r=\"27\" stroke=\"#F56A00\" stroke-width=\"2\"></circle><path stroke=\"#FF944C\" stroke-width=\"4\" d=\"m51.081 15.914-34 34\"></path>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_7]))
}
export default { render: render }